export default __webpack_public_path__ + "static/media/mobile_img_0.eede9ae1.jpg";